export enum PermissionKeys {
  // ===== Core =====
  CreateProduct = 'createProductAllowed',
  EditProduct = 'editProductAllowed',
  SubscriptionsPage = 'subscriptionsPageAllowed',

  // ===== Community =====
  Community = 'community',
  CommunityAll = 'community.allAllowed',
  CommunityCreatePosts = 'community.createPostsAllowed',
  CommunitySettings = 'community.settingsAllowed',
  CommunityMembers = 'community.membersAllowed',
  CommunityManageRooms = 'community.manageRoomsAllowed',
  CommunityAddRoom = 'community.addRoomAllowed',

  // ===== Page Builder =====
  PageBuilder = 'pageBuilder',
  PageBuilderAll = 'pageBuilder.allAllowed',
  PageBuilderCreatePage = 'pageBuilder.createNewPageAllowed',
  PageBuilderEditPage = 'pageBuilder.editPageAllowed',
  PageBuilderDeletePage = 'pageBuilder.deletePageAllowed',

  // ===== Admin Root =====
  AdminAll = 'Admin.allAllowed',

  // ===== Admin → Settings =====
  AdminSettingsAll = 'Admin.settings.allAllowed',
  AdminSettingsGeneral = 'Admin.settings.generalAllowed',
  AdminSettingsMyAccount = 'Admin.settings.myAccountAllowed',

  // ---- Integrations ----
  AdminSettingsIntegrationsAll = 'Admin.settings.integrations.allAllowed',
  AdminSettingsIntegrations = 'Admin.settings.integrations',
  AdminSettingsIntegrationsStripe = 'Admin.settings.integrations.activateStripeAllowed',
  AdminSettingsIntegrationsStripeTax = 'Admin.settings.integrations.stripeTaxAllowed',
  AdminSettingsIntegrationsPaypal = 'Admin.settings.integrations.paypalAllowed',
  AdminSettingsIntegrationsZapier = 'Admin.settings.integrations.zapierIntegrationAllowed',
  AdminSettingsIntegrationsPabbly = 'Admin.settings.integrations.pabblyIntegrationAllowed',
  AdminSettingsIntegrationsZoom = 'Admin.settings.integrations.zoomIntegrationAllowed',
  AdminSettingsIntegrationsOchAPI = 'Admin.settings.integrations.ochAPIAllowed',
  AdminSettingsIntegrationsFacebookPixel = 'Admin.settings.integrations.facebookPixelAllowed',
  AdminSettingsIntegrationsGoogleAnalytics = 'Admin.settings.integrations.googleAnalyticsAllowed',
  AdminSettingsIntegrationsThirdPartyScripts = 'Admin.settings.integrations.thirdPartyScriptsAllowed',

  // ---- Other Settings ----
  AdminSettingsDomainName = 'Admin.settings.domainNameAllowed',
  AdminSettingsBrandingTheme = 'Admin.settings.brandingAndThemeAllowed',
  AdminSettingsNavigationsSocials = 'Admin.settings.navigationsAndSocialsAllowed',
  AdminSettingsAI = 'Admin.settings.aiSettingsAllowed',
  AdminSettingsEmailTemplates = 'Admin.settings.emailTemplatesAllowed',

  // ---- Email Marketing ----
  AdminSettingsEmailMarketing = 'Admin.emailMarketingAllowed',


  // ---- Question Bank ----
  AdminSettingsQuestionBank = 'Admin.questionBankAllowed',

  // ---- Review Assessments ----
  AdminSettingsReviewAssessments = 'Admin.reviewAssessmentsAllowed',

  // ---- Manage Assignments ----
  AdminSettingsManageAssignments = 'Admin.manageAssignmentsAllowed',

  // ---- Bulk Emails ----
  AdminSettingsBulkEmails = 'Admin.bulkEmailsAllowed',

  // ---- Course Bundles ----
  AdminSettingsCourseBundles = 'Admin.courseBundlesAllowed',

  // ---- Subscription Coupons ----
  AdminSettingsSubscriptionCoupons = 'Admin.subscriptionCouponsAllowed',

  // ---- Affiliate Program ----
  AdminSettingsAffiliateProgram = 'Admin.yourAffiliateProgramAllowed',

  // ===== Admin → Analytics =====
  AdminAnalyticsAll = 'Admin.analytics.allAllowed',
  AdminAnalyticsSales = 'Admin.analytics.salesAnalyticsAllowed',
  AdminAnalyticsOrders = 'Admin.analytics.ordersAnalyticsAllowed',
  AdminAnalyticsEngagement = 'Admin.analytics.engagementAnalyticsAllowed',

  // ===== Admin → Team Members =====
  AdminSettingsTeamMembers = 'Admin.teamMembers',
  AdminTeamMembersAll = 'Admin.teamMembers.allAllowed',
  AdminTeamMembersAdd = 'Admin.teamMembers.addTeamMembersAllowed',
  AdminTeamMembersManageRoles = 'Admin.teamMembers.manageRolesAllowed',

  // ---- Manage Students ----
  AdminSettingsStudents = 'Admin.students',
  AdminSettingsStudentsAll = 'Admin.students.allAllowed',
  AdminSettingsStudentsManage = 'Admin.students.manageStudentsAllowed',
  AdminSettingsStudentsProgress = 'Admin.students.studentProgressAllowed',
}
